import type { Components, Theme } from "@mui/material/styles";

export const MuiListItemText: Components<Theme>["MuiListItemText"] = {
  styleOverrides: {
    primary: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      color: "black",
      fontWeight: theme.typography.fontWeightMedium,
    }),
    secondary: ({ theme }) => ({
      color: theme.palette.divider,
      fontSize: theme.typography.fontSizeLg,
      fontWeight: theme.typography.fontWeightBold,
    }),
    // multiline applied when both primary and secondary are set
    multiline: {
      "& span": {
        marginBottom: 5,
      },
    },
  },
};
